// extracted by mini-css-extract-plugin
module.exports = {"root":"OneLine__root___TkN8l behaviors__textCutoff___q2UEq"};